import {Component, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MvsCoreService} from "../../../../core/shared/service/mvs-core.service";
import {MvsObjectNavigationService} from "../../../../core/shared/navigation/mvs-object-navigation.service";
import {WidgetFactory} from "../../../../core/shared/widget/service/widget.factory";
import {Sorting} from "../../../../core/shared/misc/sorting";
import {ConfigPageComponent} from "../../../../core/shared/mvs-page/config-page.component";
import {WidgetConfigInterface} from "../../../../core/shared/mvs-page/interface/widget-config-page.interface";
import {WidgetData} from "../../../../core/shared/widget/widget-data";
import {PageHeaderConfig} from "../../../../core/shared/service/page/page-header-config.interface";
import {
    MvsConfigHeaderComponent
} from "../../../../core/shared/components/mvs-config-header/mvs-config-header.component";
import {NavigationItem} from "../../../../core/shared/dto/navigation/navigation-item";
import {MvsObjectNavigationEntry} from "../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectIdentifier} from "../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../core/shared/basic/object-identifier-data";

@Component({
    selector: 'lg-config-page',
    templateUrl: './jb-config-page.page.html',
    styleUrls: ['./jb-config-page.page.scss'],
    standalone: false
})
export class JbConfigPagePage extends ConfigPageComponent {

    defaultLabel: string = 'Job-Konfiguration';

    override navigationItems: NavigationItem[] = [
        {
            label: 'Job-Typen',
            action: 'jobTypes',
            tooltip: 'Job-Typen verwalten',
            icon: 'fa-solid fa-list-check',
            toggleable: false,
            default: true
        },
        {
            label: 'Protokoll',
            action: 'runLog',
            tooltip: 'Ausführungsprotokoll',
            icon: 'fa-solid fa-clipboard-list',
            toggleable: false,
            default: false
        }
    ];

    // Empty widgets map — all widgets are lazy-created in postNavigationSelection()
    // to avoid firing unused QL queries on initial page load (CONFIG-022).
    override widgets: { [key: string]: WidgetConfigInterface } = {};

    // Lazy widgets — created only when their nav item is opened.
    jbJobTypeWidget: WidgetData | null = null;
    jbJobRunLogWidget: WidgetData | null = null;

    constructor(protected route: ActivatedRoute, protected coreService: MvsCoreService, protected navigationService: MvsObjectNavigationService) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes)
    }

    ngOnDestroy() {
        super.ngOnDestroy()
    }

    override postNavigationSelection(): void {
        if (this.activeNavigationItem?.action === 'jobTypes' && !this.jbJobTypeWidget) {
            this.jbJobTypeWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
                'jb-config-page-job-type-widget.new',
                'Job-Typen',
                'jb.JbJobType',
            );
        }

        if (this.activeNavigationItem?.action === 'runLog' && !this.jbJobRunLogWidget) {
            this.jbJobRunLogWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
                'jb-config-page-job-run-log-entry-widget.new',
                'Protokoll',
                'jb.JbJobRunLogEntry'
            );
        }
    }

    handleEntitySelect(event: ObjectIdentifierData | ObjectIdentifier): void {
        this.navigationService.navigateTo(
            MvsObjectNavigationEntry.createNavigationEntry(
                event.objectType, event.objectId, 'object', '', '', '',
                MvsObjectNavigationActionEnum.edit
            )
        );
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Job-Konfiguration',
                categoryTypeMode: 'ticket',
                icon: 'fa-light fa-cards-blank'
            }
        };
    }

    isNavComponent(): NavigationItem[] {
        return this.navigationItems;
    }

}
